import { Box, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import type { FC } from "react";
import { FONT_SIZE, INK, OUTREACH_POPUP } from "@/theme/tokens";
import { SystemGrantBars } from "@/ui/DataViz/SystemGrantBars/SystemGrantBars";
import { OutreachMatch, type OutreachScoredPerson } from "@/utils/models";
import { ONE_LINE } from "./outreachRowLayout";
import type { OutreachCopy } from "./useOutreachCopy";

/** How many of the meter's four segments each match fills; a long shot fills none. */
const MATCH_SEGMENTS: Record<OutreachMatch, number> = {
	[OutreachMatch.Great]: 4,
	[OutreachMatch.Good]: 3,
	[OutreachMatch.Fair]: 2,
	[OutreachMatch.Maybe]: 1,
	[OutreachMatch.LongShot]: 0,
};
const METER_LENGTH = 4;

/** The match strength as a four-segment meter and its label, in a fixed column so a group's meters line up. */
export const OutreachMatchMeter: FC<{ person: OutreachScoredPerson; copy: OutreachCopy; dataTestId: string }> = ({ person, copy, dataTestId }) => {
	const theme = useTheme();
	const label = copy.matchLabel(person.match);
	const filled = MATCH_SEGMENTS[person.match];
	return (
		<Box sx={{ width: OUTREACH_POPUP.ROW_MATCH_WIDTH, flexShrink: 0, display: "flex", alignItems: "center", gap: 1 }}>
			<SystemGrantBars
				showCount={false}
				ariaLabel={label}
				height={OUTREACH_POPUP.MATCH_SEGMENT_HEIGHT}
				segmentWidth={OUTREACH_POPUP.MATCH_SEGMENT_WIDTH}
				fill={theme.palette.primary.main}
				emptyFill={alpha(theme.palette.primary.main, OUTREACH_POPUP.MATCH_EMPTY_ALPHA)}
				segments={Array.from({ length: METER_LENGTH }, (_, index) => ({ id: String(index), filled: index < filled }))}
				dataTestId={`${dataTestId}-meter`}
			/>
			<Typography component="span" aria-hidden sx={{ ...ONE_LINE, fontSize: FONT_SIZE.CAPTION, fontWeight: 600, color: INK.SECONDARY }}>
				{label}
			</Typography>
		</Box>
	);
};
